import React from "react";
// import "./styles.scss";

interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  variant: "border-white" | "border-black";
}

const StyledButton = ({
  className,
  variant,
  children,
  ...rest
}: ButtonProps) => {
  return variant === "border-black" ? (
    <button
      {...rest}
      className={`${className} button-border-black transition duration-500 hover:scale-[1.02] hover:shadow-lg`}
    >
      {children}
    </button>
  ) : (
    <button
      {...rest}
      className={`${className} button-border-white transition duration-500 hover:scale-[1.02] hover:shadow-lg`}
    >
      {children}
    </button>
  );
};

export default StyledButton;
